import { render, staticRenderFns } from "./HospitalKanban.vue?vue&type=template&id=07761791&scoped=true"
import script from "./HospitalKanban.vue?vue&type=script&lang=ts"
export * from "./HospitalKanban.vue?vue&type=script&lang=ts"
import style0 from "./HospitalKanban.vue?vue&type=style&index=0&id=07761791&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07761791",
  null
  
)

export default component.exports